import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const RedirectMFAPage = () => {

    const navigate = useNavigate();

    useEffect(()=>{
        const code =new URLSearchParams(window.location.search).get('code') || '';
        const state= new URLSearchParams(window.location.search).get('state') || ''
        sessionStorage.setItem('mfacode',code);
        sessionStorage.setItem('mfastate',state);
        const stepString = sessionStorage.getItem('step')
        const redirectOrigin = sessionStorage.getItem('redirectOrgin')
        const samlFlow = sessionStorage.getItem('samlFlow')
        const tree = sessionStorage.getItem('authIndexValue')
        if(!!stepString){
        const step = JSON.parse(stepString);
        if(!!step && !!step.payload && !!redirectOrigin ){
            // if (!!samlFlow){
            //     let queryParam


            //     // let goto = new URLSearchParams(redirectOrigin).get('goto') || ''
            //     // if (goto && goto != null && goto != '' && goto != undefined) {
            //         if (redirectOrigin.substring(redirectOrigin.length - 2) === '\#' ){

            //             queryParam = '&code='+code+'&state='+state;
            //             let redirectOri = redirectOrigin.substring(0,redirectOrigin.length -2)
            //             window.location.href=redirectOri+queryParam+'\#';

            //         }
            //         else if (redirectOrigin.substring(redirectOrigin.length - 2) === '/#'){
            //             queryParam = '&code='+code+'&state='+state;
            //             let redirectOri = redirectOrigin.substring(0,redirectOrigin.length -2)
            //             window.location.href=redirectOri+queryParam+'/#';
            //         }
            //     // }else{
            //     //   queryParam = '?code='+code+'&state='+state+'&authIndexValue='+tree
            //     // }
            // } else {
                window.location.href=redirectOrigin;
            // }
        }
        }
    })

    return (<></>)

}

export default RedirectMFAPage;